import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { Button } from "reactstrap";
import { getDropdownCountryList } from "../../../service/rak-beneficiary-service";

const RakFilterBy = ({
  show = false,
  onHide,
  saveButtonClicked,
  type,
  profileStatus,
  setProfileStatus,
  setType,
  country,
  setCountry,
  status,
  setStatus,
  setFilterLength,
  filterLength,
  setNoOfFiltersSelected,
}) => {
  // const [type, setType] = useState([]);
  // const [country, setCountry] = useState([]);
  // const [status, setStatus] = useState();
  // const [typeLength, setTypeLength] = useState("");
  // const [countryLength, setCountryLength] = useState("");
  // const [statusLength, setStatusLength] = useState("");

  const [typeList, setTypeList] = useState([
    { value: "CashPickUP", label: "Cash Pickup" },
    { value: "BankTransfer", label: "Bank Transfer" },
  ]);
  const [countryList, setCountryList] = useState([]);
  const [statusList, setStatusList] = useState([
    { value: "Approved", label: "Approved" },
    { value: "Pending", label: "Pending" },

    { value: "FAILED", label: "Failed to Verify" },
  ]);
  const [profileStatusList, setProfileStatusList] = useState([
    { value: "Created", label: "Created" },
    { value: "Pending", label: "Pending" },
    { value: "Missing", label: "Missing" },
  ]);
  useEffect(() => {
    getDropdownCountryListDD();
  }, []);

  const getDropdownCountryListDD = () => {
    //   api calls :
    getDropdownCountryList()
      .then((getDropdownCountryListRes) => {
        console.log({ getDropdownCountryListRes });
        if (getDropdownCountryListRes && getDropdownCountryListRes.data) {
          let data = getDropdownCountryListRes.data.map((element) => {
            element.label = element.name || "";
            element.value = element.code || "";
            return element;
          });
          setCountryList(data);
        }
      })
      .catch((getDropdownCountryListErr) => {
        console.log({ getDropdownCountryListErr });
        setCountryList([]);
      });
  };
  console.log("setNoOfFiltersSelected", setNoOfFiltersSelected);

  return (
    <>
      <Modal
        onHide={onHide}
        show={show}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="rak-beneficiary-modal"
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Select
              closeMenuOnSelect={true}
              isMulti
              placeholder="Type"
              onChange={(data) => {
                console.log("Selected Type", data);
                setType(data);
                setFilterLength((prevState) => ({
                  ...prevState,
                  typeLength: (data && data.length) || "",
                }));
              }}
              options={typeList}
              value={type}
            />
          </div>
        </Modal.Body>
        <Modal.Body>
          <div>
            <Select
              closeMenuOnSelect={true}
              isMulti
              placeholder="Country"
              onChange={(data) => {
                console.log(data);
                setCountry(data);
                setFilterLength((prevState) => ({
                  ...prevState,
                  countryLength: (data && data.length) || "",
                }));
              }}
              options={countryList}
              value={country}
            />
          </div>
        </Modal.Body>
        <Modal.Body>
          <div>
            <Select
              closeMenuOnSelect={true}
              isMulti
              placeholder="Profile Status"
              onChange={(data) => {
                setProfileStatus(data);
                setFilterLength((prevState) => ({
                  ...prevState,
                  profileStatusLength: (data && data.length) || "",
                }));
              }}
              options={profileStatusList}
              value={profileStatus}
            />
          </div>
        </Modal.Body>
        <Modal.Body>
          <div>
            <Select
              closeMenuOnSelect={true}
              isMulti
              placeholder="Status"
              onChange={(data) => {
                setStatus(data);
                setFilterLength((prevState) => ({
                  ...prevState,
                  statusLength: (data && data.length) || "",
                }));
              }}
              options={statusList}
              value={status}
            />
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              onHide();
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            color="primary"
            onClick={() => {
              let req = {};
              req.type = type;
              req.country = country;
              req.status = status;
              req.profileStatus = profileStatus;
              req.typeLength = filterLength.typeLength;
              req.countryLength = filterLength.countryLength;
              req.statusLength = filterLength.statusLength;
              req.profileStatusLength = filterLength.profileStatusLength;
              let temp =
                (filterLength.typeLength || 0) +
                (filterLength.countryLength || 0) +
                (filterLength.statusLength || 0) +
                (filterLength.profileStatusLength || 0);
              console.log("noOfFiltersSelected1", temp);
              setNoOfFiltersSelected(temp);
              temp = 0;
              saveButtonClicked(req);
            }}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RakFilterBy;
